/* RealBio — explorador de evidencia clínica.

   Los datos van aquí, en el propio activo, y no en metafields: son citas
   verificadas contra PubMed y deben cambiar sólo cuando alguien las revisa,
   no desde el editor de temas.

   REGLA INVIOLABLE DE ESTE FICHERO: toda entrada lleva n, duracion y pmid.
   Si una cifra no tiene los tres, no entra. Y los ensayos que fallaron su
   endpoint primario se incluyen con fallo:true — son la mitad del valor de
   la herramienta, porque ningún proveedor del sector los enseña. */
(function () {
  'use strict';

  var DATOS = {
    semaglutida: {
      nombre: 'Semaglutida',
      dosis: {
        '2.4mg': {
          etiqueta: '2,4 mg semanal',
          desenlaces: {
            peso: [{
              ensayo: 'STEP 1', cifra: '−14,9 %',
              que: 'Cambio medio de peso corporal frente a −2,4 % con placebo.',
              n: '1.961', duracion: '68 semanas',
              diseno: 'Fase 3, aleatorizado, doble ciego',
              fuente: 'Wilding JPH, et al. N Engl J Med. 2021;384(11):989-1002',
              pmid: '33567185'
            }],
            cardiovascular: [{
              ensayo: 'SELECT', cifra: 'HR 0,80',
              que: 'Reducción del desenlace cardiovascular compuesto: 6,5 % frente a 8,0 %. IC 95 % 0,72–0,90.',
              n: '17.604', duracion: '39,8 meses de seguimiento',
              diseno: 'Fase 3, aleatorizado, doble ciego',
              fuente: 'Lincoff AM, et al. N Engl J Med. 2023;389(24):2221-2232',
              pmid: '37952131'
            }],
            retirada: [{
              ensayo: 'STEP 4', cifra: '+6,9 %',
              que: 'Peso recuperado por quienes pasaron a placebo tras 20 semanas de tratamiento, frente a −7,9 % adicional en quienes continuaron.',
              n: '803', duracion: '20 + 48 semanas',
              diseno: 'Fase 3a, retirada aleatorizada',
              fuente: 'Rubino D, et al. JAMA. 2021;325(14):1414-1425',
              pmid: '33755728',
              nota: 'Diferencia entre brazos de 14,8 puntos porcentuales. El efecto no persistió tras la retirada abrupta.'
            }]
          }
        }
      }
    },

    tirzepatida: {
      nombre: 'Tirzepatida',
      dosis: {
        '15mg': {
          etiqueta: '15 mg semanal',
          desenlaces: {
            peso: [{
              ensayo: 'SURMOUNT-1', cifra: '−20,9 %',
              que: 'Cambio medio de peso corporal frente a −3,1 % con placebo.',
              n: '2.539', duracion: '72 semanas',
              diseno: 'Fase 3, aleatorizado, doble ciego',
              fuente: 'Jastreboff AM, et al. N Engl J Med. 2022;387(3):205-216',
              pmid: '35658024'
            }],
            retirada: [{
              ensayo: 'SURMOUNT-4', cifra: '+14,0 %',
              que: 'Peso recuperado por quienes pasaron a placebo tras 36 semanas, frente a −5,5 % adicional en quienes continuaron.',
              n: '670', duracion: '36 + 52 semanas',
              diseno: 'Fase 3, retirada aleatorizada',
              fuente: 'Aronne LJ, et al. JAMA. 2024;331(1):38-48',
              pmid: '38078870',
              nota: 'Diferencia entre brazos de 19,4 puntos porcentuales.'
            }]
          }
        },
        'max': {
          etiqueta: 'Dosis máxima tolerada',
          desenlaces: {
            peso: [{
              ensayo: 'SURMOUNT-5', cifra: '−20,2 %',
              que: 'Comparación directa frente a semaglutida, que obtuvo −13,7 % en la misma población.',
              n: '751', duracion: '72 semanas',
              diseno: 'Fase 3b, aleatorizado, abierto, comparación directa',
              fuente: 'Aronne LJ, et al. N Engl J Med. 2025;393(1):26-36',
              pmid: '40353578',
              nota: 'Es el único ensayo que comparó ambas moléculas en la misma población. Fue abierto, no ciego.'
            }]
          }
        }
      }
    },

    retatrutida: {
      nombre: 'Retatrutida',
      dosis: {
        '12mg': {
          etiqueta: '12 mg semanal',
          desenlaces: {
            peso: [{
              ensayo: 'Fase 2 obesidad', cifra: '−24,2 %',
              que: 'Cambio medio de peso frente a −2,1 % con placebo.',
              n: '338', duracion: '48 semanas',
              diseno: 'Fase 2, aleatorizado, doble ciego',
              fuente: 'Jastreboff AM, et al. N Engl J Med. 2023;389(6):514-526',
              pmid: '37366315',
              nota: 'Fase 2, no fase 3. Los resultados del programa TRIUMPH en obesidad sólo existen en notas de prensa del patrocinador, sin publicación revisada por pares.'
            }, {
              ensayo: 'TRANSCEND-T2D-1', cifra: '−15,3 %',
              que: 'Cambio de peso en diabetes tipo 2 frente a −2,6 % con placebo. HbA1c −1,94 %.',
              n: '537', duracion: 'fase 3',
              diseno: 'Fase 3, aleatorizado',
              fuente: 'Bajaj HS, et al. Lancet. 2026;407(10546):2402-2413',
              pmid: '42250575',
              nota: 'Primera fase 3 de retatrutida publicada en revisión por pares. Es en diabetes tipo 2, no en obesidad pura.'
            }]
          }
        }
      }
    },

    tb500: {
      nombre: 'TB-500 / timosina beta-4',
      dosis: {
        'na': {
          etiqueta: 'No aplicable',
          desenlaces: {
            general: [{
              ensayo: 'ARISE-3', cifra: 'Endpoint no alcanzado', fallo: true,
              que: 'El ensayo de timosina beta-4 completa (RGN-259) en ojo seco no alcanzó sus endpoints primarios.',
              n: '700', duracion: 'no publicado',
              diseno: 'Fase 3, aleatorizado',
              fuente: 'Registro NCT03937882 · resultados comunicados en marzo de 2021',
              pmid: '',
              nota: 'Además: el producto comercializado como TB-500 es el fragmento 17-23 (7 aminoácidos), NO la timosina beta-4 completa (43). La evidencia de RGN-259 no le corresponde.'
            }, {
              ensayo: 'Sosne 2015', cifra: 'Endpoint no alcanzado', fallo: true,
              que: 'Ensayo de timosina beta-4 en ojo seco: endpoints primarios negativos; algunos secundarios alcanzaron significación.',
              n: '72', duracion: 'no aplicable',
              diseno: 'Aleatorizado, controlado',
              fuente: 'Sosne G, Ousler GW. Clin Ophthalmol. 2015;9:877-84',
              pmid: '26056426'
            }, {
              ensayo: 'Guarnera 2010', cifra: '≈25 %',
              que: 'Cicatrización completa de úlceras cutáneas a 3 meses con timosina beta-4 tópica al 0,03 %.',
              n: '73', duracion: '3 meses',
              diseno: 'Estudio clínico, vía tópica',
              fuente: 'Guarnera G, et al. Ann N Y Acad Sci. 2010;1194:207-12',
              pmid: '20536470',
              nota: 'Vía tópica y molécula completa. No extrapolable al fragmento ni a vía sistémica.'
            }]
          }
        }
      }
    },

    argireline: {
      nombre: 'Argireline (acetil hexapéptido-8)',
      dosis: {
        'topico': {
          etiqueta: 'Aplicación tópica',
          desenlaces: {
            general: [{
              ensayo: 'An 2019', cifra: 'p < 0,05',
              que: 'Superior al control en un diseño de media cara, que elimina la variabilidad entre personas.',
              n: '52 (50 completaron)', duracion: 'no aplicable',
              diseno: 'Doble ciego, aleatorizado, split-face',
              fuente: 'An JH, et al. Ann Dermatol. 2019;31(3):263-271',
              pmid: '33911590'
            }, {
              ensayo: 'Kraeling 2015', cifra: '0,22 %',
              que: 'Penetración en piel humana. El mecanismo de "bótox tópico" que se le atribuye no es compatible con esta cifra.',
              n: 'piel humana', duracion: 'no aplicable',
              diseno: 'Estudio de permeación',
              fuente: 'Kraeling ME, et al. Cutan Ocul Toxicol. 2015;34(1):46-52',
              pmid: '24754410',
              nota: 'El efecto medido es real, pero probablemente no ocurre por el mecanismo que dice el marketing.'
            }]
          }
        }
      }
    },

    ghkcu: {
      nombre: 'GHK-Cu',
      dosis: {
        'na': {
          etiqueta: 'No aplicable',
          desenlaces: {
            general: [{
              ensayo: 'Sin ensayo clínico', cifra: 'No existe', fallo: true,
              que: 'No hay ningún ensayo controlado aleatorizado de GHK-Cu en solitario para arrugas en humanos. Una revisión de 2024 lo describe como "una ausencia sorprendente de estudios clínicos".',
              n: '—', duracion: '—',
              diseno: 'Revisión de la literatura',
              fuente: 'Mortazavi SM, Hosseinzadeh H. BioImpacts. 2024;15:30071',
              pmid: '39963574',
              nota: 'La evidencia in vitro sí es sólida (Maquart 1988, PMID 3169264), pero es en fibroblastos en cultivo, no en piel humana viva.'
            }]
          }
        }
      }
    }
  };

  var ETIQ_DESENLACE = {
    peso: 'Cambio de peso corporal',
    cardiovascular: 'Desenlace cardiovascular',
    retirada: 'Qué pasa al suspender',
    general: 'Evidencia disponible'
  };

  function opciones(sel, pares, valor) {
    sel.innerHTML = '';
    pares.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[0];
      o.textContent = p[1];
      sel.appendChild(o);
    });
    if (valor) sel.value = valor;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function tarjeta(e) {
    var pm = e.pmid
      ? '<a href="https://pubmed.ncbi.nlm.nih.gov/' + esc(e.pmid) + '/" target="_blank" rel="nofollow noopener">PMID ' + esc(e.pmid) + '</a>'
      : 'sin publicación revisada por pares';

    return '<article class="rb-exp__card' + (e.fallo ? ' rb-exp__card--fallo' : '') + '">'
      + '<p class="rb-exp__ens">' + esc(e.ensayo) + (e.fallo ? ' · endpoint no alcanzado' : '') + '</p>'
      + '<p class="rb-exp__cifra">' + esc(e.cifra) + '</p>'
      + '<p class="rb-exp__que">' + esc(e.que) + '</p>'
      + '<div class="rb-exp__datos">'
      +   '<span><b>N</b> ' + esc(e.n) + '</span>'
      +   '<span><b>Duración</b> ' + esc(e.duracion) + '</span>'
      +   '<span><b>Diseño</b> ' + esc(e.diseno) + '</span>'
      +   '<span><b>Fuente</b> ' + esc(e.fuente) + ' · ' + pm + '</span>'
      + '</div>'
      + (e.nota ? '<p class="rb-exp__nota">' + esc(e.nota) + '</p>' : '')
      + '</article>';
  }

  function init(app) {
    var selC = app.querySelector('[data-exp-comp]');
    var selD = app.querySelector('[data-exp-dosis]');
    var selE = app.querySelector('[data-exp-desenlace]');
    var out = app.querySelector('[data-exp-salida]');
    if (!selC || !selD || !selE || !out) return;

    opciones(selC, Object.keys(DATOS).map(function (k) { return [k, DATOS[k].nombre]; }));

    function pintarDosis() {
      var c = DATOS[selC.value];
      opciones(selD, Object.keys(c.dosis).map(function (k) { return [k, c.dosis[k].etiqueta]; }));
      pintarDesenlaces();
    }

    function pintarDesenlaces() {
      var d = DATOS[selC.value].dosis[selD.value];
      opciones(selE, Object.keys(d.desenlaces).map(function (k) {
        return [k, ETIQ_DESENLACE[k] || k];
      }));
      pintar();
    }

    function pintar() {
      var d = DATOS[selC.value].dosis[selD.value];
      var lista = d && d.desenlaces[selE.value];
      out.innerHTML = (lista && lista.length)
        ? lista.map(tarjeta).join('')
        : '<p class="rb-exp__vacio">No hay ensayos publicados para esa combinación.</p>';
    }

    selC.addEventListener('change', pintarDosis);
    selD.addEventListener('change', pintarDesenlaces);
    selE.addEventListener('change', pintar);
    pintarDosis();
  }

  function arranca() {
    document.querySelectorAll('[data-rb-exp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
